
import { formatDateObject } from '@/utils/formUtils'
import { posterType, posterStatus } from '@/json/index'
import { getEnumeration } from 'enumeration'
export function handlePoster (item) {
  item['publishTime_copy'] = item.publishTime ? formatDateObject(item.publishTime) : '--'
  item['createTime_copy'] = item.createTime ? formatDateObject(item.createTime) : '--'
  item['poster_type'] = item.type ? getEnumeration(item.type, posterType) : '--'
  item['visibleInToolsCopy'] = item.visibleInTools ? '是' : '否'
  if (item.rightText) {
    item.rightText = item.rightText.replace(/[\r\n]/g, '<br>')
  }
  if (!item.published && item.status === 'APPROVED') {
    item['status_copy'] = '已下架'
  } else {
    item['status_copy'] = item.status ? getEnumeration(item.status, posterStatus) : '--'
  }
  // return item
}
